import * as React from "react"
import {Box} from "@mui/material";
import {ButtonSeeker, IconSeeker, ModalSeeker} from "@ui-seeker/core";

import {useProductsMatcherImageComparisonNavigator} from "../../@hooks";
import {productsMatcherImageComparatorModalData} from "../../@signals";
import ProductsMatcherImageComparisonModalContainer from "./Container";
import ProductsMatcherImageComparisonModalCounter from "./Counter";
import ProductsMatcherImageComparisonModalArrow from "./Arrow";


export default function ProductsMatcherImageComparisonModal({  brandOptions=[], setSelectedSKU, saveMapping  }) {
	const { isOpen, numOptions, localIndex, handleNavigateLeft, handleNavigateRight } = useProductsMatcherImageComparisonNavigator(brandOptions, setSelectedSKU)

	return <ModalSeeker
		hideActions
		isOpen={isOpen}
		title="Image Comparison"
		controller={() => productsMatcherImageComparatorModalData.value = {}}
		containerProps={{ fullScreen: true }}
	>
		<Box
			maxWidth={1}
			mx="auto"
			p={2}
		>
			<Box display="flex" flexDirection="column" gap={2}>
				<Box display="flex" alignItems="center" justifyContent="space-between" width={1}>
					<ProductsMatcherImageComparisonModalCounter
						numOptions={numOptions}
						localIndex={localIndex}
					/>

					<ButtonSeeker
						color="success"
						startIcon={<IconSeeker icon="badge-check" />}
						onClick={() => {
							saveMapping?.()
							productsMatcherImageComparatorModalData.value = {}
						}}
					>
						Validate
					</ButtonSeeker>
				</Box>


				<Box
					display="flex"
					gap={2}
					alignItems="stretch"
					justifyContent="center"
					height="75vh"
					sx={{ position: 'relative' }}
				>
					<ProductsMatcherImageComparisonModalArrow
						orientation="left"
						brandOptionsLength={numOptions}
						localIndex={localIndex}
						onNavigate={handleNavigateLeft}
					/>
					<ProductsMatcherImageComparisonModalArrow
						orientation="right"
						brandOptionsLength={numOptions}
						localIndex={localIndex}
						onNavigate={handleNavigateRight}
					/>
					<ProductsMatcherImageComparisonModalContainer
						fullURL={productsMatcherImageComparatorModalData.value?.fullUrlLeft}
						url={productsMatcherImageComparatorModalData.value.urlLeft}
						label="Target"
						labelColor="default"
						productName={productsMatcherImageComparatorModalData.value?.skuName}
					/>
					<ProductsMatcherImageComparisonModalContainer
						fullURL={productsMatcherImageComparatorModalData.value?.fullUrlRight}
						url={productsMatcherImageComparatorModalData.value.urlRight}
						label="Selected"
						labelColor="primary"
						productName={productsMatcherImageComparatorModalData.value?.candidateName}
					/>
				</Box>
			</Box>
		</Box>
	</ModalSeeker>
}
